import React from 'react';
import { makeStyles } from '@material-ui/core';
import { useTranslation } from '@michelin/central-provider';
import { ProgressDots } from './ProgressDots';

const useStyles = makeStyles(() => ({
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '14px 20px',
    borderTop: '1px solid #eee',
  },
  buttons: {
    display: 'flex',
    '& > * + *': {
      marginLeft: 8,
    },
  },
  backButton: {
    padding: '8px 16px',
    fontSize: 13,
    fontWeight: 600,
    fontFamily: 'inherit',
    color: '#333',
    background: '#fff',
    border: '1px solid #ccc',
    borderRadius: 8,
    cursor: 'pointer',
    '&:hover': {
      background: '#f4f5f7',
    },
  },
  nextButton: {
    padding: '8px 16px',
    fontSize: 13,
    fontWeight: 600,
    fontFamily: 'inherit',
    color: '#fff',
    background: '#0b2e59',
    border: 'none',
    borderRadius: 8,
    cursor: 'pointer',
    '&:hover': {
      background: '#123a6e',
    },
  },
}));

export interface FooterProps {
  index: number;
  total: number;
  isLast: boolean;
  onBack?: () => void;
  onNext: () => void;
}

export function Footer({ index, total, isLast, onBack, onNext }: FooterProps) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.footer}>
      <ProgressDots index={index} total={total} />
      <div className={classes.buttons}>
        {onBack && (
          <button type="button" className={classes.backButton} onClick={onBack}>
            {t('\u2190 Back')}
          </button>
        )}
        <button type="button" className={classes.nextButton} onClick={onNext}>
          {isLast ? t('Finish') : t('Next \u2192')}
        </button>
      </div>
    </div>
  );
}

export default Footer;
